/**
 * Build-time feature flags, injected as a comma-separated `REACT_APP_FEATURES` string.
 * Unset or empty means no feature is enabled.
 */

/** Resolve instance ids to `account - name` via the customer portal API. */
export const FEATURE_INSTANCE_NAME = 'INSTANCE_NAME';

export const parseFeatures = (raw: string | undefined): string[] =>
  (raw ?? '')
    .split(',')
    .map((feature) => feature.trim().toUpperCase())
    .filter(Boolean);

export const isFeatureEnabled = (feature: string): boolean =>
  parseFeatures(process.env.REACT_APP_FEATURES).includes(feature.trim().toUpperCase());
